import { ComponentProps, ElementType } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './card.scss';

type Props<T extends ElementType = 'div'> = ComponentProps<T> & {
    shadow?: boolean;
    as?: T;
};
export const Card = <T extends ElementType = 'div'>({ className, shadow, as, ...props }: Props<T>) => {
    return (
        <Layout
            element={as || 'div'}
            className={cn('card', shadow && 'card--with-shadow', className)}
            {...props}
        />
    );
};
